/* Wallware Landing Page — Shared JS
 * Handles: cart integration, push-button swatches, finish explorer,
 * style card links, and FAQ accordion.
 */
(function () {
  'use strict';

  /* ================================================================
   * 1. CART HELPERS
   * ============================================================= */

  /**
   * Fetch latest cart, update header badge, open Pipeline cart drawer.
   */
  function openCartDrawer() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', { bubbles: true })
          );
        }
      })
      .catch(function (err) {
        console.error('[ww] Failed to refresh cart', err);
      });
  }

  /**
   * POST one or more items to the Shopify cart.
   * @param {Array<{id:number|string, quantity:number}>} items
   * @returns {Promise<Object>} Resolved cart line data
   */
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add-to-cart failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        openCartDrawer();
        return data;
      })
      .catch(function (err) {
        console.error('[ww] addToCart error', err);
        throw err;
      });
  }

  /* ================================================================
   * 2. PUSH BUTTON — swatch selection + bundle ATC
   * ============================================================= */

  function initPushButton() {
    var section = document.querySelector('.ww-pb');
    if (!section) return;

    var variantData = window.wwPushButton;
    if (!variantData) {
      console.warn('[ww] window.wwPushButton data missing');
      return;
    }

    var cards = section.querySelectorAll('.ww-pb__card[data-style]');

    cards.forEach(function (card) {
      var style = card.dataset.style;
      var swatches = card.querySelectorAll('.ww-pb__swatch');
      var atcBtn = card.querySelector('.ww-pb__atc');
      var heroImg = card.querySelector('.ww-pb__hero-img');

      /* --- Swatch click --- */
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var finish = this.dataset.finish;

          /* Active state */
          swatches.forEach(function (s) { s.classList.remove('ww-pb__swatch--active'); });
          this.classList.add('ww-pb__swatch--active');

          /* Update ATC data attribute */
          if (atcBtn) atcBtn.dataset.finish = finish;

          /* Swap hero image */
          var imageMap = style === 'century' ? variantData.centuryImages : variantData.futuraImages;
          if (heroImg && imageMap && imageMap[finish]) {
            heroImg.src = imageMap[finish];
          }

          /* Swap comparison slider image */
          var compareImg = section.querySelector('.ww-pb__compare-layer--' + style + ' img');
          if (compareImg && imageMap && imageMap[finish]) {
            compareImg.src = imageMap[finish];
          }
        });
      });

      /* --- ATC click --- */
      if (atcBtn) {
        atcBtn.addEventListener('click', function () {
          var finish = this.dataset.finish;
          var switchId = variantData.switchVariants && variantData.switchVariants[finish];
          var plateVariants = style === 'century' ? variantData.centuryPlateVariants : variantData.futuraPlateVariants;
          var plateId = plateVariants && plateVariants[finish];

          if (!switchId || !plateId) {
            console.error('[ww] Missing variant data for', style, finish);
            return;
          }

          var items = [
            { id: switchId, quantity: 1 },
            { id: plateId, quantity: 1 }
          ];

          if (!items.length) {
            console.error('[ww] No variant IDs for', style, finish);
            return;
          }

          var origText = this.textContent;
          this.textContent = 'Adding...';
          this.disabled = true;

          addToCart(items)
            .then(function () {
              atcBtn.textContent = origText;
              atcBtn.disabled = false;
            })
            .catch(function () {
              atcBtn.textContent = origText;
              atcBtn.disabled = false;
            });
        });
      }
    });
  }

  /* ================================================================
   * 3. FINISH EXPLORER — style/finish filtering + ATC
   * ============================================================= */

  function initFinishExplorer() {
    var explorer = document.querySelector('.ww-finish-explorer');
    if (!explorer) return;

    var styleButtons = explorer.querySelectorAll('.ww-fe__style-btn');
    var finishTabs = explorer.querySelectorAll('.ww-fe__finish-tab');
    var finishPanels = explorer.querySelectorAll('.ww-fe__finish-panel');
    var styleGroups = explorer.querySelectorAll('.ww-fe__style-group[data-style]');

    /* Defaults */
    var activeStyle = 'all';
    var activeFinish = finishTabs.length
      ? finishTabs[0].dataset.finish
      : null;

    function update() {
      /* Style buttons */
      styleButtons.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.style === activeStyle);
      });

      /* Finish tabs — hide Coal Black when Century is selected */
      finishTabs.forEach(function (tab) {
        tab.classList.toggle('active', tab.dataset.finish === activeFinish);
        if (tab.dataset.futuraOnly === 'true') {
          tab.style.display = activeStyle === 'century' ? 'none' : '';
        }
      });
      /* If Century is selected and Coal Black was active, fall back to Polished Brass */
      if (activeStyle === 'century' && activeFinish === 'Coal Black Brass') {
        activeFinish = 'Polished Brass';
        finishTabs.forEach(function (tab) {
          tab.classList.toggle('active', tab.dataset.finish === activeFinish);
        });
        finishPanels.forEach(function (panel) {
          panel.classList.toggle('ww-fe__finish-panel--active', panel.dataset.finish === activeFinish);
        });
      }

      /* Finish panels */
      finishPanels.forEach(function (panel) {
        panel.classList.toggle(
          'ww-fe__finish-panel--active',
          panel.dataset.finish === activeFinish
        );
      });

      /* Style groups within active panel */
      styleGroups.forEach(function (group) {
        if (activeStyle === 'all') {
          group.style.display = '';
        } else {
          group.style.display =
            group.dataset.style === activeStyle ? '' : 'none';
        }
      });
    }

    /* --- Style button clicks --- */
    styleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeStyle = this.dataset.style;
        update();
      });
    });

    /* --- Finish tab clicks --- */
    finishTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeFinish = this.dataset.finish;
        update();
      });
    });

    /* --- ATC buttons inside explorer --- */
    explorer.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.ww-fe__atc');
      if (!atcBtn) return;

      var variantId = atcBtn.dataset.variantId;
      if (!variantId) return;

      var origText = atcBtn.textContent;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;

      addToCart([{ id: Number(variantId), quantity: 1 }])
        .then(function () {
          atcBtn.textContent = origText;
          atcBtn.disabled = false;
        })
        .catch(function () {
          atcBtn.textContent = origText;
          atcBtn.disabled = false;
        });
    });

    /* --- Public filter API (used by style cards) --- */
    window.wwFilterExplorer = function (style, finish) {
      if (style) activeStyle = style;
      if (finish) activeFinish = finish;
      update();
      explorer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    /* Initial render */
    update();
  }

  /* ================================================================
   * 4. STYLE CARDS — link to Finish Explorer
   * ============================================================= */

  function initStyleCards() {
    /* Swatch click: jump to explorer with style + finish */
    document.querySelectorAll('.ww-sc__swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var style = this.dataset.style;
        var finish = this.dataset.finish;
        if (window.wwFilterExplorer) {
          window.wwFilterExplorer(style, finish);
        }
      });
    });

    /* CTA click: jump to explorer with style, keep current finish */
    document.querySelectorAll('.ww-sc__cta').forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var style = this.dataset.style;
        if (window.wwFilterExplorer) {
          window.wwFilterExplorer(style, null);
        }
      });
    });
  }

  /* ================================================================
   * 5. FAQ ACCORDION — single-open <details> elements
   * ============================================================= */

  function initFaqAccordion() {
    var items = document.querySelectorAll('.ww-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (this.open) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  }

  /* ================================================================
   * 6. COMPARE SLIDER — before/after drag
   * ============================================================= */

  function initCompareSlider() {
    var container = document.querySelector('.ww-pb__compare-inner');
    if (!container) return;

    var futuraLayer = container.querySelector('.ww-pb__compare-layer--futura');
    var centuryLayer = container.querySelector('.ww-pb__compare-layer--century');
    var handle = container.querySelector('.ww-pb__compare-handle');
    var dragging = false;
    var sliderPos = 50;

    /* Mobile tab elements */
    var tabBar = document.querySelector('.ww-pb__tab-bar');
    var tabs = tabBar ? tabBar.querySelectorAll('.ww-pb__tab') : [];
    var tabIndicator = tabBar ? tabBar.querySelector('.ww-pb__tab-indicator') : null;
    var futuraCard = document.querySelector('.ww-pb__split-card--futura');
    var centuryCard = document.querySelector('.ww-pb__split-card--century');
    var activeTab = 'futura';

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function setPosition(pct, animate) {
      sliderPos = Math.max(5, Math.min(95, pct));
      var transition = animate ? 'clip-path 0.35s ease, left 0.35s ease' : 'none';
      futuraLayer.style.transition = transition;
      centuryLayer.style.transition = transition;
      handle.style.transition = animate ? 'left 0.35s ease' : 'none';
      futuraLayer.style.clipPath = 'inset(0 ' + (100 - sliderPos) + '% 0 0)';
      centuryLayer.style.clipPath = 'inset(0 0 0 ' + sliderPos + '%)';
      handle.style.left = sliderPos + '%';
    }

    function setPositionFromX(x) {
      var rect = container.getBoundingClientRect();
      var pct = ((x - rect.left) / rect.width) * 100;
      setPosition(pct, false);
    }

    function switchTabOnly(style) {
      activeTab = style;
      if (tabs.length) {
        tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.style === style); });
      }
      if (tabIndicator) {
        tabIndicator.classList.toggle('century', style === 'century');
      }
      if (futuraCard) futuraCard.classList.toggle('ww-pb__split-card--hidden', style !== 'futura');
      if (centuryCard) centuryCard.classList.toggle('ww-pb__split-card--hidden', style !== 'century');
    }

    function switchTab(style) {
      activeTab = style;
      if (tabs.length) {
        tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.style === style); });
      }
      if (tabIndicator) {
        tabIndicator.classList.toggle('century', style === 'century');
      }
      if (futuraCard) futuraCard.classList.toggle('ww-pb__split-card--hidden', style !== 'futura');
      if (centuryCard) centuryCard.classList.toggle('ww-pb__split-card--hidden', style !== 'century');
      /* High % = Futura visible (left), low % = Century visible (right) */
      setPosition(style === 'futura' ? 85 : 15, true);
    }

    function onDragEnd() {
      if (!dragging) return;
      dragging = false;
      if (isMobile()) {
        /* Auto-switch tabs at 60%, but don't snap the slider position */
        if (sliderPos > 55 && activeTab !== 'futura') {
          switchTabOnly('futura');
        } else if (sliderPos < 45 && activeTab !== 'century') {
          switchTabOnly('century');
        }
        /* Otherwise let it stay wherever the user left it */
      }
    }

    /* Drag events */
    container.addEventListener('mousedown', function (e) {
      dragging = true;
      setPositionFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) {
      if (dragging) setPositionFromX(e.clientX);
    });
    document.addEventListener('mouseup', onDragEnd);

    container.addEventListener('touchstart', function (e) {
      dragging = true;
      setPositionFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (dragging) {
        e.preventDefault();
        setPositionFromX(e.touches[0].clientX);
      }
    }, { passive: false });
    document.addEventListener('touchend', onDragEnd);

    /* Tab clicks (mobile) */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(this.dataset.style);
      });
    });

    /* On mobile load, hide Century card by default */
    if (isMobile() && centuryCard) {
      centuryCard.classList.add('ww-pb__split-card--hidden');
    }
  }

  /* ================================================================
   * BOOT
   * ============================================================= */

  document.addEventListener('DOMContentLoaded', function () {
    initPushButton();
    initFinishExplorer();
    initStyleCards();
    initFaqAccordion();
    initCompareSlider();
  });
})();
